var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-modal',{attrs:{"modal-id":_vm.modalId,"title":_vm.title,"preloader":_vm.preloader,"modal-size":"default","modal-alignment":"top"},on:{"submit":_vm.submit,"close-modal":_vm.closeModal}},[_c('template',{slot:"header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close outline-none",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',[_c('app-icon',{attrs:{"name":'x'}})],1)])]),_vm._v(" "),_c('template',{slot:"body"},[(_vm.preloader)?_c('app-overlay-loader'):_vm._e(),_vm._v(" "),_c('form',{ref:"form",staticClass:"mb-0",attrs:{"data-url":_vm.selectedUrl ? `/request/${_vm.inputs.id}` : '/request'}},[_c('div',{staticClass:"row"},[(
            ['OICC', 'OEYC', 'OENY', 'OCLN', 'OINSP'].includes(this.activity)
          )?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(["OICC"].includes(this.activity)
                ? "Campo de ensayo"
                : ["OEYC", "OENY"].includes(this.activity)
                ? "Área metrológica/Campo"
                : ["OCLN"].includes(this.activity)
                ? "Campo de análisis"
                : ["OINSP"].includes(this.activity)
                ? "Tipo de inspección o metodología"
                : "Nivel 3"))]),_vm._v(" "),_c('app-input',{attrs:{"type":"select","required":true,"list":[
                { id: '', value: this.$t('select_option') },
                ...this.scopes.level3,
              ]},model:{value:(_vm.inputs.level3),callback:function ($$v) {_vm.$set(_vm.inputs, "level3", $$v)},expression:"inputs.level3"}})],1)]):_vm._e(),_vm._v(" "),(['OICC', 'OCLN'].includes(this.activity))?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(["OICC", "OCLN"].includes(this.activity) ? "Técnica" : "Nivel 4"))]),_vm._v(" "),_c('app-input',{attrs:{"type":"select","required":true,"list":[
                { id: '', value: this.$t('select_option') },
                ...this.scopes.level4,
              ]},model:{value:(_vm.inputs.level4),callback:function ($$v) {_vm.$set(_vm.inputs, "level4", $$v)},expression:"inputs.level4"}})],1)]):_vm._e(),_vm._v(" "),(
            [
              'OICC',
              'OEYC',
              'OENY',
              'OCLN',
              'OCPR',
              'OCPE',
              'OINSP',
              'OCSG',
              'CSST',
              'CSIA',
              'CSA',
              'CSGAS',
              'CSEN'
            ].includes(this.activity)
          )?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(["OICC"].includes(this.activity)
                ? "Ensayo"
                : ["OEYC", "OENY"].includes(this.activity)
                ? "Magnitud submagnitud"
                : ["OCLN"].includes(this.activity)
                ? "Análisis"
                : ["OCPR"].includes(this.activity)
                ? "Producto ,proceso o servicio"
                : ["OCPE"].includes(this.activity)
                ? "Personal certificado"
                : ["OINSP"].includes(this.activity)
                ? "Campo de inspección"
                : ["OCSG", "CSIA", "CSA", "CSGAS", "CSST", "CSEN"].includes(this.activity)
                ? "Categoría"
                : "Nivel 5"))]),_vm._v(" "),_c('app-input',{attrs:{"type":"select","required":true,"list":[
                { id: '', value: this.$t('select_option') },
                ...this.scopes.level5,
              ]},model:{value:(_vm.inputs.level5),callback:function ($$v) {_vm.$set(_vm.inputs, "level5", $$v)},expression:"inputs.level5"}})],1)]):_vm._e(),_vm._v(" "),(
            [
              'OICC',
              'OEYC',
              'OENY',
              'OCLN',
              'OCPE',
              'OINSP',
              'OCSG',
              'CSST',
              'CSIA',
              'CSA',
              'CSGAS',
              'CSEN'
            ].includes(this.activity)
          )?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(["OICC"].includes(this.activity)
                ? "Producto o material a ensayar"
                : ["OEYC", "OENY"].includes(this.activity)
                ? "Tipos  Instrumentos a calibrar"
                : ["OCLN"].includes(this.activity)
                ? "Muestra"
                : ["OCPR"].includes(this.activity)
                ? "Categoría de producto, proceso o servicio"
                : ["OCPE"].includes(this.activity)
                ? "Categoría de personal"
                : ["OINSP"].includes(this.activity)
                ? "Elemento a inspeccionar"
                : ["OCSG", "CSIA", "CSA", "CSGAS", "CSST", "CSEN"].includes(this.activity)
                ? "Campo de certificación Sector IAF"
                : "Nivel 6"))]),_vm._v(" "),_c('app-input',{attrs:{"type":"select","required":true,"list":[
                { id: '', value: this.$t('select_option') },
                ...this.scopes.level6,
              ]},model:{value:(_vm.inputs.level6),callback:function ($$v) {_vm.$set(_vm.inputs, "level6", $$v)},expression:"inputs.level6"}})],1)]):_vm._e(),_vm._v(" "),(['OICC', 'OEYC', 'OENY', 'OCLN'].includes(this.activity))?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(["OICC", "OEYC", "OENY"].includes(this.activity)
                ? "Rango"
                : ["OCLN"].includes(this.activity)
                ? "Método"
                : "Nivel 7"))]),_vm._v(" "),_c('app-input',{attrs:{"type":"text","required":true,"placeholder":'Ingrese el ' +
                (['OICC', 'OEYC', 'OENY'].includes(this.activity)
                  ? 'rango'
                  : ['OCLN'].includes(this.activity)
                  ? 'método'
                  : 'mivel 7')},model:{value:(_vm.inputs.level7),callback:function ($$v) {_vm.$set(_vm.inputs, "level7", $$v)},expression:"inputs.level7"}})],1)]):_vm._e(),_vm._v(" "),(['OEYC', 'OENY'].includes(this.activity))?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(["OEYC", "OENY"].includes(this.activity)
                ? "Incertidumbre"
                : "Nivel 8"))]),_vm._v(" "),_c('app-input',{attrs:{"type":"text","required":true,"placeholder":'Ingrese ' +
                (['OEYC', 'OENY'].includes(this.activity)
                  ? 'la encertidumbre'
                  : 'el nivel 8')},model:{value:(_vm.inputs.level8),callback:function ($$v) {_vm.$set(_vm.inputs, "level8", $$v)},expression:"inputs.level8"}})],1)]):_vm._e()])])],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"btn btn-secondary mr-2",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.closeModal}},[_vm._v("\n      Cerrar\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._v("\n      Guardar\n    ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }